import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: left;
    gap: 15px;
    margin: 0 0 1rem 0;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: #0a043c;
  }

  .icon {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .buttonsEnd {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 15px;
    padding-bottom: 20px;
  }
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 0 0 3px;

  .fields {
    display: flex;
    flex-direction: column;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 13px;
  }

  .input {
    width: 98%;
    border-radius: 10px;
    background: #fafafa;
    border: 1px solid #e5e7eb;
  }

  .textArea {
    width: 98%;
    border-radius: 10px;
    background: #fafafa;
    border: 1px solid #e5e7eb;
    height: 100px;
    padding: 8px 12px;
    font-size: 12px;
  }

  .warn {
    font-size: 10px;
    color: #737b8c;
  }

  .optionals {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }

  .optional {
    color: #90a1b9;
  }

  .headers {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .header {
    display: flex;
    justify-content: center;
    padding: 10px;
    width: 90px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 12px;
    gap: 5px;
    align-items: center;
    cursor: pointer;
  }

  .headers .header img.icon {
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
    object-fit: contain;
    display: block;
  }

  .addVariable {
    font-size: 12px;
    color: #3e50f4;
    cursor: pointer;
    width: fit-content;
  }

  .addButton {
    width: fit-content;
    padding: 8px 12px;
    font-size: 12px;
    border: 1px solid#e2e8f0;
    border-radius: 8px;
    color: #737373;
    cursor: pointer;
  }
`;

export const ExampleVariables = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  border: 1px solid #b8e6fe;
  background-color: #f0f9ff;
  border-radius: 10px;
  padding: 8px 12px;
  gap: 10px;
  margin-bottom: 15px;

  .titleVariables {
    font-size: 12px;
    font-weight: 600;
  }

  .textVariables {
    font-size: 10px;
    color: #45556c;
  }

  .exampleVariables {
    display: flex;
    flex-direction: row;
    gap: 10px;
    font-size: 12px;
  }

  .firstName {
    display: flex;
    flex-direction: row;
    width: 60%;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 8px 10px;
    color: #62748e;
  }

  .name {
    width: 40%;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 10px;
  }

  .example {
    width: 60%;
  }

  .arrow {
    display: flex;
    align-items: center;
    width: 40%;
    color: #90a1b9;
  }
`;

export const ButtonAdded = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  background-color: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px 12px;
  width: 98%;

  .titleButtonAdded {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }

  .contentButtonAdded {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }

  .buttonAdded {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .textButtonAddedQuick {
    width: 70%;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .type {
    font-size: 10px;
  }

  .divButton {
    display: flex;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
  }

  .inputButton {
    width: 100%;
    border-radius: 10px;
    background: #fafafa;
    border: 1px solid #e5e7eb;
  }

  .textButtonAdded {
    width: 35%;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;
